import { z } from "zod";
import { WHATSAPP_IMAGE_MIME_TYPES } from "./whatsapp-image-limits.js";
export const WHATSAPP_TEMPLATE_HEADER_FORMATS = [
    "NONE",
    "TEXT",
    "IMAGE",
    "VIDEO",
    "DOCUMENT",
    "LOCATION",
    "UNKNOWN",
];
/** Durable R2 metadata stored on WhatsAppTemplate.headerMedia. Never a Meta handle. */
export const whatsAppTemplateHeaderMediaRecordSchema = z.object({
    version: z.literal(1),
    storageKey: z.string().min(1).max(512),
    mimeType: z.enum(WHATSAPP_IMAGE_MIME_TYPES),
    byteSize: z.number().int().positive(),
    fileName: z.string().min(1).max(255),
});
/** Client-safe template header image metadata. No storage keys. */
export const whatsAppTemplateHeaderMediaDtoSchema = z.object({
    mimeType: z.enum(WHATSAPP_IMAGE_MIME_TYPES),
    byteSize: z.number().int().positive(),
    fileName: z.string().min(1).max(255),
});
export function toWhatsAppTemplateHeaderMediaDto(record) {
    return {
        mimeType: record.mimeType,
        byteSize: record.byteSize,
        fileName: record.fileName,
    };
}
export function parseWhatsAppTemplateHeaderMediaRecord(value) {
    const parsed = whatsAppTemplateHeaderMediaRecordSchema.safeParse(value);
    return parsed.success ? parsed.data : null;
}
export function readWhatsAppTemplateHeaderFormat(components) {
    if (!Array.isArray(components)) {
        return "NONE";
    }
    for (const entry of components) {
        if (!entry || typeof entry !== "object" || Array.isArray(entry))
            continue;
        const component = entry;
        const type = typeof component.type === "string" ? component.type.trim().toUpperCase() : "";
        if (type !== "HEADER")
            continue;
        const format = typeof component.format === "string" ? component.format.trim().toUpperCase() : "TEXT";
        switch (format) {
            case "TEXT":
                return "TEXT";
            case "IMAGE":
                return "IMAGE";
            case "VIDEO":
                return "VIDEO";
            case "DOCUMENT":
                return "DOCUMENT";
            case "LOCATION":
                return "LOCATION";
            default:
                return "UNKNOWN";
        }
    }
    return "NONE";
}
//# sourceMappingURL=whatsapp-template-header.js.map